import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Typography, Autocomplete, FormControl, TextField, Radio, RadioGroup, FormControlLabel, Checkbox } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useLocation, useNavigate } from 'react-router-dom';
import Toastmessage from '../../components/Toast';
import { authApi } from '../../api/api';
import { useSelector } from 'react-redux';
import { logout } from '../../features/auth/AuthSlice';
import { useDispatch } from 'react-redux'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';


const TimesheetReport = () => {
    const location = useLocation();
    const { initial } = location.state || {};
    const { name } = location.state || {};
    const [dateType, setDateType] = useState('month');
    const [selectedUser, setSelectedUser] = useState({ full_name: name, initial: initial });
    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');
    const [monthOption, setMonthOption] = useState([]);
    const [yearOption, setYearOption] = useState([]);
    const [userOption, setUserOptions] = useState([]);
    const [yearColumn, setYearColumn] = useState([]);
    const [rowsyear, setRowsyear] = useState([]);
    const [paymentrow, setPaymentrow] = useState([]);
    const [rowsBonus, setRowsBonus] = useState([]);
    const [rows, setRows] = useState([]);
    const [productionRows, setProductionRows] = useState([]);
    const token = useSelector((state) => state.auth.token); // Get the token from Redux
    const userID = useSelector((state) => state.auth.id); // Get the userID from Redux
    const dispatch = useDispatch()
    const navigate = useNavigate();


    useEffect(() => {
        if (initial) {
            // setSelectedUser({ full_name: name, initial: initial })
            fetchUsers();

            if (dateType === 'month') {
                if (month) {
                    fetchMonthReport()
                }
            } else {
                if (year) {
                    fetchYearReport()
                }
            }
        }
    }, [token, userID, initial, dateType, selectedUser, month, year]); // Run effect when token or userID changes

    useEffect(() => {
        fetcYearMonth()
    }, []); // Run effect when token or userID changes


    // Define fetchLocations separately to reuse it
    const fetcYearMonth = async () => {
        const input_token = 'TIMESHEET_MONTH_YEAR'; // Replace with your actual token
        const apiUrl = 'get_month_year'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                console.log(data.month_year[0])
                setYearOption(data.year);
                setMonthOption(data.month_year)
                setMonth(data.month_year[0])
                setYear(data.year[0])
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };


    // Define fetchLocations separately to reuse it
    const fetchUsers = async () => {
        const input_token = 'ALL_EMPLOYEES'; // Replace with your actual token
        const apiUrl = 'list_of_all_employee'; // Replace with the actual API endpoint
        const dataInput = {
            login_user_id: userID
        };
        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                const statesArray = data.clients.map(user => ({
                    full_name: user.full_name, // Match `getOptionLabel`
                    initial: user.initial
                }));
                setUserOptions(statesArray);
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };
    const fetchMonthReport = async () => {
        const input_token = selectedUser.initial + 'WEEKLY_REPORT_BY_USER'; // Replace with your actual token
        const apiUrl = 'timesheet_weekly_report_by_user'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID,
            user_initial: selectedUser.initial,
            month_year: month,
            // year: "2024",
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {

                setRows(data?.weekly_report?.report)
                setProductionRows(data?.weekly_report?.Productionrows)

            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };


    const fetchYearReport = async (initial) => {
        const input_token = selectedUser.initial + 'YEARLY_REPORT_BY_USER'; // Replace with your actual token
        const apiUrl = 'timesheet_yearly_report_by_user'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID,
            user_initial: selectedUser.initial,
            // month: "12",
            year: year,
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                // Convert array and add flex: 1
                const columns = data?.column.map(col => ({ ...col, flex: 1 }));
                setYearColumn(columns)
                setRowsyear(data?.yearly_report)
                setRowsBonus(data?.bonus)
                setPaymentrow(data?.payment)
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };

    // Handle radio change
    const handleDateTypeChange = (event) => {
        setDateType(event.target.value);
    };

    const columns = [
        {
            field: 'week', headerName: 'Week', flex: 1, width: 150, renderCell: (params) => (
                <p
                    style={{ fontWeight: 'bold', cursor: 'pointer', color: 'var(--primary-color)' }}

                >
                    {params.value}
                </p>
            ),
        },
        { field: 'billable_hours', headerName: 'Billable Hours', type: 'number', flex: 1, width: 180 },
        { field: 'no_charge_billable_hours', headerName: 'No Charge Billable', type: 'number', flex: 1, width: 180 },
        { field: 'credit_or_refund', headerName: 'Credit or Refund Issued (-)', type: 'number', flex: 1, width: 220 },
        { field: 'total_hours', headerName: 'Total Hours', type: 'number', flex: 1, width: 150 },
        { field: 'required_hours', headerName: 'Required Hours', type: 'number', flex: 1, width: 180 },
        {
            field: 'over_under',
            headerName: 'Over / Under',
            type: 'number',
            flex: 1,
            width: 160,
            renderCell: (params) => {
                const value = params.value;
                const percent_complete = params.row.percent_complete; // Access percent_complete from row
                const color = percent_complete >= 90 ? 'green' : 'red'; // Conditional color based on percent_complete
                return (
                    <div style={{ color }}>
                        {value}
                    </div>
                );
            },
        },
        { field: 'no_charge_non_billable_hours', headerName: 'No Charge Non-Billable', type: 'number', flex: 1, width: 220 },
        {
            field: 'percent_complete', headerName: 'Percent Complete', type: 'number', flex: 1, width: 180, renderCell: (params) => {
                const value = params.value;
                const color = value >= 90 ? 'green' : 'red'; // Conditional color based on value
                return (
                    <div style={{ color }}>
                        {`${value}%`}
                    </div>
                );
            },
        },
        {
            field: 'is_approved', headerName: 'Approved', flex: 1, width: 180, renderCell: (params) => {
                // Check if this is the last row (total row) and do not render the checkbox
                if (params.row.id === 'total') {
                    return null; // Don't render the checkbox in the total row
                }

                const handleCheckboxChange = async (event) => {
                    const newApprovedValue = event.target.checked ? 1 : 0;

                    // Update the checkbox state immediately in the grid
                    params.api.updateRows([{ id: params.id, approved: newApprovedValue }]);

                    // Call your API here to update the status on the server
                    const response = await updateApprovalStatus(params.row, newApprovedValue);

                };

                return (
                    <div>
                        <FormControlLabel
                            control={
                                <Checkbox checked={params.value} onChange={handleCheckboxChange} name="gilad" />
                            }
                            label={params.value === 1 ? 'Yes' : 'No'}
                        />
                    </div>
                );
            },
        }
    ];






    // Example API call function to update the approval status
    const updateApprovalStatus = async (params, status) => {
        // Placeholder for your API call
        const input_token = 'APPROVE_WEEKLY_TIMESHEET'; // Replace with your actual token
        const apiUrl = 'approve_weekly_timesheet'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID,
            user_initial: params?.user_initial,
            week_start: params?.week_start,
            week_end : params?.week_end,
            approved_status: status,
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                // Convert array and add flex: 1
                await Toastmessage(data.message, true);
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };
    const Productioncolumns = [
        { field: 'label', headerName: 'Required Production', flex: 1.5 },
        { field: 'value', headerName: 'value', flex: .6 },
        { field: 'date', headerName: 'PTO CLE/PL CE Dates', flex: 1, },
    ];
    return (
        <Box
            sx={{
                backgroundColor: 'var(--theme-bg-light)',
                padding: 3
            }}
        >
            <Box>
                <Box sx={{ margin: 'auto' }}>
                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
                        Timesheet Reports
                    </Typography>

                    <Grid container spacing={2} alignItems="center">
                        {/* Left Section: Country and Date Picker */}
                        <Grid size={3}>
                            <FormControl fullWidth variant="outlined" sx={{ minWidth: 150 }}>
                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>
                                    Select User
                                </Typography>
                                <Autocomplete
                                    options={userOption} // Populate with `userOption` state
                                    getOptionLabel={(option) => option.full_name} // Access `full_name` field
                                    value={selectedUser}
                                    onChange={(event, newValue) => {
                                        setSelectedUser(newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select user"
                                            variant="outlined"
                                            InputProps={{
                                                ...params.InputProps,
                                                sx: { borderRadius: '8px' },
                                            }}
                                        />
                                    )}
                                    sx={{ width: '100%' }}
                                />

                            </FormControl>
                        </Grid>

                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Grid size={2}>
                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>
                                    {dateType === 'month' ? 'Month' : 'Year'}
                                </Typography>
                                {dateType === 'month' ? (
                                    <Autocomplete
                                        options={monthOption} // Array of month-year strings
                                        value={month} // Value is a string
                                        onChange={(event, newValue) => setMonth(newValue)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Select month & year"
                                                variant="outlined"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    sx: { borderRadius: '8px', backgroundColor: 'var(--theme-bg-light)' },
                                                }}
                                            />
                                        )}
                                        sx={{ width: '100%' }}
                                    />
                                ) : (
                                    <Autocomplete
                                        options={yearOption} // Array of month-year strings
                                        value={year} // Value is a string
                                        onChange={(event, newValue) => setYear(newValue)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Select month & year"
                                                variant="outlined"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    sx: { borderRadius: '8px', backgroundColor: 'var(--theme-bg-light)' },
                                                }}
                                            />
                                        )}
                                        sx={{ width: '100%' }}
                                    />
                                )}
                            </Grid>
                        </LocalizationProvider>

                        <Grid size={4}>
                            <FormControl
                                sx={{ display: 'flex', flexDirection: "row", alignItems: 'center', mt: 4 }}
                            >
                                <RadioGroup
                                    sx={{ display: 'flex', flexDirection: "row", alignItems: 'center' }}
                                    value={dateType}
                                    onChange={handleDateTypeChange}
                                >
                                    <FormControlLabel value="month" control={<Radio size="small" />} label="Month" />
                                    <FormControlLabel value="year" control={<Radio size="small" />} label="Year" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                    </Grid>
                </Box>
                {dateType === 'month' ? (
                    <>
                        <Box sx={{ width: '100%', marginTop: '20px' }}>
                            <DataGrid
                                rows={rows}
                                columns={columns}
                                disableSelectionOnClick
                                pagination={false}
                                className="data-grid"
                                getRowClassName={(params) =>
                                    params.id === 'total' ? 'total-row' : ''
                                }
                                sx={{
                                    '& .total-row': {

                                        fontWeight: 'bold',
                                    },
                                    '& .MuiDataGrid-columnHeader': {

                                        fontWeight: 'bold',
                                        whiteSpace: 'normal',
                                        wordWrap: 'break-word',
                                    },

                                    '& .MuiDataGrid-footerContainer': {
                                        display: 'none',
                                    },
                                }}
                            />
                        </Box>

                        <Box sx={{ marginTop: '20px' }}>
                            <Grid container spacing={2}>
                                <Grid size={12}>
                                    <DataGrid
                                        rows={productionRows}
                                        columns={Productioncolumns}
                                        hideFooter
                                        autoHeight
                                        className="data-grid"
                                        disableColumnMenu
                                        sx={{
                                            '& .MuiDataGrid-columnHeader': {

                                                fontWeight: 'bold',
                                                whiteSpace: 'normal',
                                                wordWrap: 'break-word',
                                            },
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </>
                ) : (
                    <>

                        <Box sx={{ width: '100%', marginTop: '20px' }}>
                            <DataGrid
                                rows={rowsyear}
                                columns={yearColumn}
                                disableSelectionOnClick
                                pagination={false}
                                className="data-grid"
                                getCellClassName={(params) => {
                                    if (
                                        (params.row.metric === "PTO/Sick" || params.row.metric === "CLE/PL CE") &&
                                        params.value > 0 &&
                                        params.field !== 'metric'
                                    ) {
                                        return 'zero-value-cell';
                                    }

                                    if (params.row.metric === "Percent Complete %" && params.field !== 'metric') {
                                        if (params.value > 90) {
                                            return 'percent-complete-high';
                                        } else if (params.value < 90) {
                                            return 'percent-complete-low';
                                        }
                                    }

                                    return params.field === 'metric' ? 'first-column' : ''; // Add class for the first column
                                }}
                                sx={{
                                    '& .total-row': {
                                        fontWeight: 'bold',
                                    },
                                    '& .zero-value-cell': {
                                        color: 'red !important',
                                        fontWeight: 'bold',
                                    },
                                    '& .percent-complete-high': {
                                        color: 'green !important',
                                        fontWeight: 'bold',
                                    },
                                    '& .percent-complete-low': {
                                        color: 'red !important',
                                        fontWeight: 'bold',
                                    },
                                    '& .MuiDataGrid-columnHeader': {
                                        fontWeight: 'bold',
                                        whiteSpace: 'normal',
                                        wordWrap: 'break-word',
                                    },
                                    '& .MuiDataGrid-footerContainer': {
                                        display: 'none',
                                    },
                                    '& .first-column': {  // Apply bold font size to the first column
                                        fontWeight: '500 !important',
                                        fontSize: '1rem !important',
                                        color: 'var(--primary-color)'
                                    },
                                }}
                            />





                        </Box>


                        <Box sx={{ width: '100%', marginTop: '20px' }}>
                            <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
                                Payment collection
                            </Typography>
                            <DataGrid
                                rows={paymentrow}
                                columns={yearColumn}
                                disableSelectionOnClick
                                pagination={false}
                                className="data-grid"
                                getCellClassName={(params) => {

                                    if (params.row.metric === "Collection %" && params.field !== 'metric') {
                                        if (params.value > 90) {
                                            return 'percent-complete-high';
                                        } else if (params.value < 90) {
                                            return 'percent-complete-low';
                                        }
                                    }

                                    return params.field === 'metric' ? 'first-column' : '';
                                }}
                                sx={{
                                    '& .total-row': {
                                        fontWeight: 'bold',
                                    },
                                    '& .MuiDataGrid-columnHeader': {
                                        fontWeight: 'bold',
                                        whiteSpace: 'normal',
                                        wordWrap: 'break-word',
                                    },
                                    '& .percent-complete-high': {
                                        color: 'green !important',
                                        fontWeight: 'bold',
                                    },
                                    '& .percent-complete-low': {
                                        color: 'red !important',
                                        fontWeight: 'bold',
                                    },
                                    '& .MuiDataGrid-footerContainer': {
                                        display: 'none',
                                    },
                                    '& .MuiDataGrid-cell:first-of-type': {
                                        fontWeight: 'bold',
                                        
                                    },
                                    '& .first-column': {  // Apply bold font size to the first column
                                            fontWeight: '500 !important',
                                            fontSize: '1rem !important',
                                            color: 'var(--primary-color)'
                                        },
                                }}
                            />
                        </Box>
                        <Box sx={{ width: '100%', marginTop: '20px' }}>
                            <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
                                Bonus
                            </Typography>
                            <DataGrid
                                rows={rowsBonus}
                                columns={yearColumn}
                                disableSelectionOnClick
                                pagination={false}
                                className="data-grid"
                                getCellClassName={(params) => {

                                    if (params.row.metric === "Total Bonus Earned" && params.field !== 'metric') {
                                        if (params.value !== 0) {
                                            return 'percent-complete-high';
                                        }
                                    }

                                    return params.field === 'metric' ? 'first-column' : '';
                                }}
                                sx={{
                                    '& .total-row': {
                                        fontWeight: 'bold',
                                    },
                                    '& .MuiDataGrid-columnHeader': {
                                        fontWeight: 'bold',
                                        whiteSpace: 'normal',
                                        wordWrap: 'break-word',
                                    },
                                    '& .percent-complete-high': {
                                        color: 'green !important',
                                        fontWeight: 'bold',
                                    },
                                    '& .MuiDataGrid-footerContainer': {
                                        display: 'none',
                                    },
                                    '& .first-column': {  // Apply bold font size to the first column
                                        fontWeight: '500 !important',
                                        fontSize: '1rem !important',
                                        color: 'var(--primary-color)'
                                    },
                                }}
                            />
                        </Box>
                    </>
                )}

            </Box>
        </Box>
    );
};

export default TimesheetReport;
